/** Lets login flow and imperative renderers use status metadata without circular imports. */
let loadStatusMetadataFn = null;
let resolveBadgePresentationFn = null;

export const registerStatusMetadataLoader = (loader) => {
  loadStatusMetadataFn = typeof loader === "function" ? loader : null;
};

/** @param {{ force?: boolean }} [options] */
export const triggerStatusMetadataLoad = (options) => loadStatusMetadataFn?.(options);

export const registerStatusBadgeResolver = (resolver) => {
  resolveBadgePresentationFn = typeof resolver === "function" ? resolver : null;
};

export const resolveStatusBadgePresentationExternal = (params) =>
  resolveBadgePresentationFn?.(params) ?? null;

export { clearStatusMetadataSessionCache } from "libs/context/statusMetadataSessionCache";
